import LegalDocument from "../../../widgets/legal/LegalDocument";

const BusinessPrivacy = () => <LegalDocument ns="privacy" path="/business-app/privacy" />;

export default BusinessPrivacy;
